<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <div class="px-0">

        <v-card-title class="headline pl-4 py-2 pr-2">
          Usuń element
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-4" v-if="itemsId">
          {{reqText}}
        </v-card-text>

        <v-card-actions class="px-4 py-4">
          <v-spacer></v-spacer>

          <v-btn
            color="primary lighten-2"
            flat="flat"
            @click="setVisbility"
          >
            Anuluj
          </v-btn>

          <v-btn
            color="primary"
            :loading="busy"
            :disabled="busy"
            @click="itemsDelete"
          >
            Usuń
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'delete-dialog',
  data: () => ({
    busy: false,
    errorMsg: null,
    error: null,
    name: null,
  }),
  computed: {
    ...mapGetters('files', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'delete';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
    itemsId() {
      return this.dialogVisibility.items_id;
    },
    reqText() {
      let text = 'Czy na pewno chcesz usunąć zaznaczony element?';
      if (this.itemsId.length > 1) {
        text = 'Czy na pewno chcesz usunąć zaznaczone elementy?';
      }
      return text;
    },
  },
  methods: {
    ...mapActions('files', [
      'setDialogVisbility',
      'deleteItems',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    async itemsDelete() {
      this.busy = true;
      await this.deleteItems({
        items_id: this.itemsId,
      });
      this.busy = false;
    },
  },
};
</script>
